import { gql } from '@apollo/client';

export const ACTIVE_BATCHES_FOR_SELECT = gql`
  query active_batches_for_select($where: active_batch_bool_exp) {
    active_batch(where: $where) {
      id
      name
      year
      intake {
        name
      }
    }
  }
`;

export const INSERT_BATCH = gql`
  mutation insert_batch($objects: [batch_insert_input!]!) {
    insert_batch(objects: $objects) {
      affected_rows
    }
  }
`;

export const BATCH_LIST = gql`
  subscription batchList($where: batch_bool_exp, $order_by: [batch_order_by!]) {
    batch(where: $where, order_by: $order_by) {
      id
      name
      year
      intakeId
      active
      course {
        code
      }
      batch_classes {
        id
        name
      }
      intake {
        id
        name
      }
    }
  }
`;

export const BATCH = gql`
  query batch($where: batch_bool_exp, $order_by: [batch_order_by!]) {
    batch(where: $where, order_by: $order_by) {
      id
      name
      year
      active
      batch_classes {
        id
        name
      }
      intake {
        id
        name
      }
      course {
        id
      }
      academic_calendar_items {
        id
        name
        semester
        type
        startDate
        endDate
      }
      course_coordinators {
        id
        semesterId
        userId
      }
    }
  }
`;

export const BATCH_FOR_STUDENT_BATCH_ASSIGNMENT = gql`
  query batchForStudentBatchAssignment($where: active_batch_bool_exp, $order_by: [active_batch_order_by!]) {
    active_batch(where: $where, order_by: $order_by) {
      id
      name
      year
      intake {
        id
        name
      }
      batch_classes {
        id
        name
      }
    }
  }
`;

export const DELETE_BATCH_CLASSES = gql`
  mutation delete_batch_class($where: batch_class_bool_exp!) {
    delete_batch_class(where: $where) {
      affected_rows
    }
  }
`;

export const DELETE_BATCH = gql`
  mutation delete_batch($where: batch_bool_exp!) {
    delete_batch(where: $where) {
      affected_rows
    }
  }
`;

export const UPDATE_BATCH = gql`
  mutation update_batch($where: batch_bool_exp!, $_set: batch_set_input) {
    update_batch(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const UPDATE_BATCH_CLASSES = gql`
  mutation update_batch_class($_set: batch_class_set_input, $where: batch_class_bool_exp!) {
    update_batch_class(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const INSERT_BATCH_CLASS = gql`
  mutation insert_batch_class($objects: [batch_class_insert_input!]!) {
    insert_batch_class(objects: $objects) {
      affected_rows
    }
  }
`;

export const INSERT_ACADEMIC_CALENDAR_ITEM = gql`
  mutation insert_academic_calendar_item($objects: [academic_calendar_item_insert_input!]!) {
    insert_academic_calendar_item(objects: $objects) {
      affected_rows
    }
  }
`;

export const UPDATE_ACADEMIC_CALENDAR_ITEM = gql`
  mutation update_academic_calendar_item(
    $where: academic_calendar_item_bool_exp!
    $_set: academic_calendar_item_set_input
  ) {
    update_academic_calendar_item(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const DELETE_ACADEMIC_CALENDAR_ITEM = gql`
  mutation delete_academic_calendar_item($where: academic_calendar_item_bool_exp!) {
    delete_academic_calendar_item(where: $where) {
      affected_rows
    }
  }
`;

export const BATCHES_FOR_TIMETABLE_SELECT = gql`
  query batches_for_timetable_select($where: active_batch_bool_exp, $order_by: [active_batch_order_by!]) {
    active_batch(where: $where, order_by: $order_by) {
      id
      name
      year
      batch_classes {
        id
        name
        batch_class_batch_subject_configurations {
          batchSubjectConfigurationId
          count
        }
        batch_class_batch_subject_extra_slot {
          batchSubjectExtraSlotId
          count
        }
      }
      intake {
        id
        name
      }
    }
  }
`;

export const BATCHES_FOR_RESULT_SHEET = gql`
  query batchesForResultSheet($where: batch_bool_exp) {
    batch(where: $where) {
      id
      name
      year
      batch_classes {
        id
        name
      }
      intake {
        id
        name
      }
    }
  }
`;

export const BATCHES_FOR_LMS = gql`
  query batchesForLMS($where: batch_bool_exp) {
    batch(where: $where) {
      id
      name
      year
      intake {
        name
      }
      batch_subject_configurations {
        id
        subject {
          code
        }
      }
      course {
        course_semesters {
          id
          semester
        }
      }
    }
  }
`;

export const BATCHES_FOR_CLASS_LIST_REPORT = gql`
  query batchesForClassListReport($where: batch_bool_exp) {
    batch(where: $where) {
      id
      name
      year
      course {
        code
        name
      }
      intake {
        name
      }
      batch_classes {
        id
        name
      }
    }
  }
`;
